import * as React from 'react';

const useUrlQueryParams = (): URLSearchParams => {
  const search = window.location.search;

  return React.useMemo(() => new URLSearchParams(search), [search]);
};

export default useUrlQueryParams;
